import { useState, useEffect } from "react";
import {
  Container,
  Center,
  Loader,
  Paper,
  Code,
  Text,
  Group,
  Button,
} from "@mantine/core";
import { getAdminJobDetails, requeueJob, requeueJobHard } from "../../api";
import JobStatusBadge from "./JobStatusBadge";
import { Link } from "wouter";
import { notifications } from "@mantine/notifications";
import JobLogs from "./JobLogs";

export default function JobDetails({ params }) {
  const [job, setJob] = useState(null);
  const [logs, setLogs] = useState([]);
  const [jobType, setJobType] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAdminJobDetails(params.id).then((data) => {
      setJob(data.job);
      setLogs(data.logs);
      setJobType(data.type);
    });
  }, [params.id]);

  if (!job)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  return (
    <Container size="lg" px={0}>
      <Paper>
        <Group>
          <Text fw={500} fz="lg">
            {job.id} ({jobType})
          </Text>
        </Group>
        <Group>
          <JobStatusBadge status={job.status} />
          {/* <Text c="dimmed">First started at: {job.firstStarted}</Text> */}
        </Group>
        <Group justify="flex-end">
          <Button
            size="sm"
            my="md"
            color="blue"
            onClick={() => {
              setIsLoading(true);
              requeueJob(job.id)
                .then(() => {
                  notifications.show({
                    title: "Job re-queued",
                    color: "green",
                  });
                  getAdminJobDetails(params.id).then((data) => {
                    setJob(data);
                    setIsLoading(false);
                  });
                })
                .catch((error) => {
                  notifications.show({
                    title: "Failed to re-queue job",
                    message: "" + error,
                    color: "red",
                  });
                  setIsLoading(false);
                });
            }}
          >
            Re-Queue Job
          </Button>

          <Button
            size="sm"
            my="md"
            color="red"
            onClick={() => {
              setIsLoading(true);
              requeueJobHard(job.id)
                .then(() => {
                  notifications.show({
                    title: "Job re-queued HARD",
                    color: "green",
                  });
                  getAdminJobDetails(params.id).then((data) => {
                    setJob(data);
                    setIsLoading(false);
                  });
                })
                .catch((error) => {
                  notifications.show({
                    title: "Failed to re-queue job",
                    message: "" + error,
                    color: "red",
                  });
                  setIsLoading(false);
                });
            }}
          >
            Re-Queue Job HARD
          </Button>
        </Group>

        {job.documentFileId && (
          <Paper my="md">
            Processed file:{" "}
            <Link to={`/documents/${job.documentFileId}`}>
              {job.documentFileId}
            </Link>
          </Paper>
        )}

        {job.tenderId && (
          <Paper my="md">
            Processed tender:{" "}
            <Link to={`/tenders/${job.tenderId}`}>{job.tenderId}</Link>
          </Paper>
        )}

        <Text mt="lg" fw={500} fz="lg">
          Logs
        </Text>
        <JobLogs logs={logs} />
      </Paper>

      <Text mt={100}>Full job JSON</Text>
      <Code mt="sm" block>
        {JSON.stringify(job, null, 2)}
      </Code>
    </Container>
  );
}
